import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import styles from './navbar.module.css';

import heartLogo from "../../../../assets/images/heart-logo.png";
import profileIcon from "../../../../assets/images/basic-details.png";
import chatIcon from "../../../../assets/images/chat.png";

import { useCookies } from '../../../../hooks/useCookies';
import { API_URL } from '../../../../api';
import * as profileAction from '../../../../actions/Profile';
import { getProfileSelfieImageUrls } from '../../../../utils/serverUtils';

export default function Navbar({ style }) {
    const navigate = useNavigate();
    const location = useLocation();
    const cookies = useCookies();
    const { getCookie, setCookie } = cookies;

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [profileImages, setProfileImages] = useState({
        main: null,
        first: null,
        second: null,
    });
    const [isRejected, setIsRejected] = useState(false);

    const currentPath = location.pathname;
    const suffix = currentPath.split("/").at(-1);

    // Fetch profile images
    const fetchProfileImages = async () => {
        try {
            const response = await fetch(`${API_URL}customer/update/media`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${getCookie('token')}`,
                },
            });
            const data = await response.json();
            if (response.ok) {
                const images = getProfileSelfieImageUrls(data);
                setProfileImages(images);
            }
        } catch (error) {
            console.error('Error fetching profile images:', error);
        }
    };

    // Handle window resizing for mobile detection
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Fetch profile images on mount
    useEffect(() => {
        fetchProfileImages();
    }, []);

    // Approval check logic
    useEffect(() => {
        if (currentPath === "/user/pause") return;

        (async () => {
            const result = await profileAction.checkApproval();
            if (result) {
                setCookie('approval', result?.approval);
                setCookie('active', result?.active);
                setIsRejected(!result?.active);

                if (!result?.active) {
                    window.location.replace("/user/pause");
                }
            }
        })();
    }, [currentPath]);

    return (
        <nav className={styles.nav} style={style}>
            <ul>
                <li
                    className={suffix === "chat" ? styles.active : ""}
                    onClick={() => !isRejected && navigate("/user/chat/matches")}
                >
                    <img src={chatIcon} alt="Chat" width={30} height={30} />
                    <div className={styles.indicator}></div>
                </li>

                <li
                    className={suffix === "home" ? styles.active : ""}
                    onClick={() => !isRejected && navigate("/user/home")}
                >
                    <img src={heartLogo} alt="Home" width={30} height={30} />
                    <div className={styles.indicator}></div>
                </li>

                <li
                    className={suffix === "updateprofile" ? styles.active : ""}
                    onClick={() => navigate("/updateprofile")}
                >
                    <img
                        style={{ borderRadius: "50%" }}
                        src={profileImages.main ? profileImages.main : profileIcon}
                        alt="Profile"
                        width={30}
                        height={30}
                    />
                    <div className={styles.indicator}></div>
                </li>
            </ul>
        </nav>
    );
}
